<script setup lang="ts">
import { onBeforeMount } from 'vue'
import { useColorModes } from '@coreui/vue-pro'

const { isColorModeSet, setColorMode } = useColorModes(
  'coreui-pro-vue-admin-template-theme-light',
)

onBeforeMount(() => {
  const param = new URLSearchParams(window.location.href.split('?')[1]).get('theme')
  /* The leading word: before the hash the value runs into it, as in ?theme=dark#/dashboard. */
  const word = param?.match(/^[A-Za-z]+/)?.[0]
  const theme = ['light', 'dark', 'auto'].find((mode) => mode === word)

  if (theme) {
    setColorMode(theme)
    return
  }

  if (isColorModeSet()) {
    return
  }

  setColorMode('light')
})
</script>

<template>
  <router-view />
</template>

<style lang="scss">
@use 'styles/style';
</style>
